import { topicPages } from "../pages/topicPages";

export const STATIC_ROUTE_PATHS = {
  home: "/",
  guide: "/guide",
  legal: "/legal",
  notFound: "/404",
};

export const prerenderRoutes = [
  {
    path: STATIC_ROUTE_PATHS.home,
    key: "home",
    sitemap: true,
    prerender: true,
  },
  {
    path: STATIC_ROUTE_PATHS.guide,
    key: "guide",
    sitemap: true,
    prerender: true,
  },
  {
    path: STATIC_ROUTE_PATHS.legal,
    key: "legal",
    sitemap: true,
    prerender: true,
  },
  ...topicPages.map((page) => ({
    path: page.slug,
    key: "topic",
    page,
    sitemap: true,
    prerender: true,
  })),
];

export const notFoundRoute = {
  path: STATIC_ROUTE_PATHS.notFound,
  key: "notFound",
  sitemap: false,
  prerender: true,
  noindex: true,
};

export const appRoutes = [...prerenderRoutes, notFoundRoute];

export const sitemapRoutes = prerenderRoutes.filter((route) => route.sitemap);
